import { createContext, useContext } from 'react';
"use strict";
const StickyGridContext = createContext(null);
function useStickyGrid() {
  const value = useContext(StickyGridContext);
  if (!value) {
    throw new Error("Please wrap this component in <StickyGrid />");
  }
  return value;
}
export { StickyGridContext, useStickyGrid };
//# sourceMappingURL=context.mjs.map
